<template>
  <div class="asc-maintenance-list-template">
    <asc-container class="asc-maintenance-container">
      <template slot="header">
        <asc-grid-wrapper-header :title="title" :tooltip="tooltip">
          <template v-if="navigationButtonVisible">
            <asc-navigation-button
              button-text="View All"
              path="/maintenance"
            ></asc-navigation-button>
          </template>
        </asc-grid-wrapper-header>
      </template>
      <template slot="subheader">
        <asc-surface-support-text
          text="Select a maintenance ID from the table to view maintenance details."
        />
      </template>
      <asc-maintenance-grid-wrapper
        :tooltip="tooltip"
        :values="values"
        :on-open="onOpen"
        :maintenance-export-table-grid-permission="
          maintenanceExportTableGridPermission
        "
        :maintenance-grid-permission="maintenanceGridPermission"
        :internal-user="internalUser"
        :grid-columns="gridColumns"
        :grid-filters="gridFilters"
        :grid-height="gridHeight"
        :export-button-visible="exportButtonVisible"
        :on-mx-rec-alerts-export="onMxRecAlertsExport"
        :on-add-manual-mx-rec="onAddManualMxRec"
        :export-menu-items="exportMenuItems"
        :persistent-grid-id="persistentGridId"
        :has-user-airline-agreement="hasUserAirlineAgreement"
        v-on="$listeners"
      ></asc-maintenance-grid-wrapper>
    </asc-container>
  </div>
</template>

<script>
import AscContainer from '@/components/atoms/AscContainer'
import AscSurfaceSupportText from '@/components/atoms/AscSurfaceSupportText'
import AscNavigationButton from '@/components/atoms/AscNavigationButton'
import { AscMaintenanceGridWrapper } from '@/components/organisms'
import AscGridWrapperHeader from '@/components/molecules/AscGridWrapperHeader'

import { AscGridPropsMixin, AscRangeDatePickerMixin } from '@/components/mixins'

export default {
  name: 'AscMaintenanceListTemplate',

  components: {
    AscContainer,
    AscGridWrapperHeader,
    AscSurfaceSupportText,
    AscNavigationButton,
    AscMaintenanceGridWrapper,
  },

  mixins: [AscGridPropsMixin, AscRangeDatePickerMixin],

  props: {
    navigationButtonVisible: {
      type: Boolean,
      default: false,
    },
    onMxRecAlertsExport: {
      type: Function,
      default: () => {},
    },
    exportMenuItems: {
      type: Array,
      default: () => [],
    },
    onAddManualMxRec: {
      type: Function,
      default: () => {},
    },

    maintenanceExportTableGridPermission: {
      type: Boolean,
      default: false,
    },
    maintenanceGridPermission: {
      type: Boolean,
      default: false,
    },
    gridHeight: {
      type: String,
      default: 'lg',
    },
    persistentGridId: {
      type: String,
      default: '',
    },
    hasUserAirlineAgreement: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="scss">
.asc-maintenance-list-template {
  .asc-container--headerWrapper {
    .asc-grid-wrapper-header--container {
      margin: 0;
    }
  }
}
</style>
